import { Component, OnInit, Output, EventEmitter, ViewChild } from "@angular/core";
import { Router } from "@angular/router";

import { State } from "@shared/models/state.interface";
import { City } from "@shared/models/city.interface";
import { ClientesService } from "../../services/clientes.service";
import { VendasService } from "../../services/vendas.service";
import { Utilservice } from "@core/services/util.service";
import { Vendedor } from "@shared/models";
import { VisitasService } from "@modules/visitas/services/visitas.service";
import * as toastr from 'toastr'
import { UfComboComponent } from "@shared/components/uf-combo/uf-combo.component";
import { Filters } from "../carteira-clientes/carteira-clientes.models";
import { FiltersOfConsult } from "@shared/utils/filters-of-consult";
import { LocationsService } from "@modules/clientes/services/locations.service";

@Component({
  selector: "app-cliente-movimentacao",
  templateUrl: "./cliente-movimentacao.component.html",
  styleUrls: ["./cliente-movimentacao.component.css"]
})
export class ClienteMovimentacaoComponent implements OnInit {
  lsStates: State[] = [];
  lsCities: City[] = [];
  lsDaysWithoutMovement: string[] = ["0 - 60", "60 - 90", "90 - 180", "180"];

  lsClients: any[] = [];

  lsClientsChecked = [];
  lsVendedores: Vendedor[] = [];

  vetorSetor: any;
  parameters2: any;

  setorSelecionado: string = "";
  vendedorSelecionado: string = "";

  vendedorLoading : boolean = false;

  setorCdFzs = null;

  parameters = {
    selectedState: null,
    selectedCity: null,
    selectedDaysWithoutMovement: 90
  };

  isRequesting: boolean = false;

  userLogado;

  @ViewChild('ufsVendedor', {static: false}) ufViewChild: UfComboComponent;

  constructor(
    private clientService: ClientesService,
    private vendaService: VendasService,
    private router: Router,
    private visitService: VisitasService,
    private locationsService: LocationsService,
  ) {}

  filtersOfConsult = new FiltersOfConsult<Filters>({
    setor: null,
    uf: null,
    cidade: null,
    bairro: '',
    vendedor: null,
    status: -1
  });

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.parameters2 = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : '',
      pedido: "",
      periodoInicial: "",
      periodoFinal: "",
      cnpj: "",
      uf: "",
      cidade: null,
      linhas: "",
      idStatus: "",
      idTabelaPreco: "",
      tipoConsulta: "",
      vendedor: null,
      CdFzs: "",
      pedidosReativos: false,
      pedidosComSaldo: false,
      pedidosTelevendas: false
    };

    if(this.userLogado.perfil == 1 || this.userLogado.perfil == 2){
      this.vetorSetor = {
        id: this.userLogado.idSetor,
        codigo: this.userLogado.setor,
      }

      this.getVendedores();
    }

    this.getStates();

    //this.getClients();
  }

  getStates() {
    this.clientService
      .getStates(this.userLogado.idSetor)
      .subscribe(data => (this.lsStates = data), error => console.log(error));
  }

  filterCities(filterVal: any) {
    if (filterVal === "undefined") return;

    if (this.userLogado.idSetor == 0) {
      this.clientService
      .getCities(this.parameters.selectedState, this.parameters2.vendedor.idSetor)
      .subscribe(
        data => {
          this.lsCities = data;
        },
        error => console.log(error)
      );

    }else{
      this.clientService
      .getCities(this.parameters.selectedState, this.userLogado.idSetor)
      .subscribe(
        data => {
          this.lsCities = data;
        },
        error => console.log(error)
      );
    }

    
  }

  getClients() {
    this.isRequesting = true;

    const parametersVendedor = { ...this.parameters2 };

    if(this.vetorSetor != undefined){

      if(!parametersVendedor.vendedor){
        toastr.error('Campo "Vendedor" Obrigatório');
        return this.isRequesting = false;
      }
      else {
        parametersVendedor.vendedor = parametersVendedor.vendedor.setor;

        this.clientService
        .getClienteSemMovimentacao(
          this.userLogado.id,
          this.parameters.selectedState,
          this.parameters.selectedCity,
          this.parameters.selectedDaysWithoutMovement,
          this.vetorSetor.codigo != null ? this.vetorSetor.codigo : null,
          parametersVendedor.vendedor
        )
        .subscribe(
          data => {
            this.isRequesting = false;

            this.lsClients = data;
          },
          error => console.log(error)
        );
      }

      
    }else{
      this.clientService
      .getClienteSemMovimentacao(
        this.userLogado.id,
        this.parameters.selectedState,
        this.parameters.selectedCity,
        this.parameters.selectedDaysWithoutMovement,
        this.setorSelecionado,
        this.vendedorSelecionado
      )
      .subscribe(
        data => {
          this.isRequesting = false;

          this.lsClients = data;
        },
        error => console.log(error)
      );
    }

    
  }

  getIdSetorComc(){
    if(this.vetorSetor){
      this.parameters2.CdFzs = this.vetorSetor.codigo;
      this.setorCdFzs = this.vetorSetor.codigo;
    }

    this.clientService.getIdSetor(this.setorCdFzs)
      .subscribe(
        data => {
          const idSetor: any = data;
          if(idSetor != 0){
            this.parameters2.idSetorComC = idSetor;
            this.parameters2.setor = idSetor;
          }else{
            toastr.error('Setor não encontrado')
          }

        },
        error => {
          console.log(error)
        }
      )
  }

  filtrarUf(){
    if(this.parameters2.vendedor) {
      this.locationsService.listUFBySectorAndSeller(this.vetorSetor.codigo, this.parameters2.vendedor.nome).subscribe(
        ufsFiltradas => {
          this.lsStates = ufsFiltradas;
          let sgMap = (ufsFiltradas.map(uf => uf.sgUf));
          this.ufViewChild.ufs = this.ufViewChild.ufs.filter(uf => sgMap.includes(uf.sgUf));
        }
      )
    } 
  }

  reset() {
    this.parameters = {
      selectedState: null,
      selectedCity: null,
      selectedDaysWithoutMovement: 90
    };

    //this.vetorSetor = null;

    this.lsClients = [];
  }

  isClientSelected(client) {
    const selected = this.lsClientsChecked;

    return selected.indexOf(client) >= 0;
  }

  onClientChange(event, client) {
    const selected = this.lsClientsChecked;
    const selectedIndex = selected.indexOf(client);

    if (selectedIndex === -1) {
      selected.push(client);
    } else {
      selected.splice(selectedIndex, 1);
    }

    this.lsClientsChecked = selected;
  }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }

  formatDate(date) {
    return Utilservice.formatDate(date);
  }

  formatCep(cep) {
    return Utilservice.formatCep(cep);
  }

  onClientVisitClicked() {
    const lsClients = this.lsClients.filter(
      value => this.lsClientsChecked.indexOf(value) >= 0
    );

    localStorage.setItem("clienteMovimentacao", JSON.stringify(lsClients));

    this.router.navigate(["/visitas/cadastro"]);
  }

  getSectorSelected(){
    console.log("Setor Selecionado", this.vetorSetor.codigo);
  }

  // getVendedores(){
  //   console.log("Setor Selecionado", this.vetorSetor.codigo);
  // }

  getVendedores(){
    this.parameters2.vendedor = '';
    this.vendedorLoading = true;
    this.visitService.getVendedoresPorSetor(this.vetorSetor.codigo).subscribe(
      data => {
        this.lsVendedores = data;

        if (data.length == 1) {
          this.parameters2.vendedor = data[0];
        }
        else {
          this.parameters2.vendedor = null;
        }

        this.vendedorLoading = false;
    },
      error => console.log(error)
    );
  }
  
}
